import { Component, OnInit } from '@angular/core';
import { Plantilla } from './plantillas.model';
import { Router } from '@angular/router';

// services
import { EventService } from 'src/app/core/service/event.service';
import { PlantillaService } from './plantillas.service';


// constants
import { EventType } from 'src/app/core/constants/events';
import { NgForm } from '@angular/forms';


@Component({
  selector: 'app-new-plantilla',
  templateUrl: './new-plantilla.component.html',
  styleUrls: ['./new-plantilla.component.scss']
})
export class NewPlantillaComponent implements OnInit {

  constructor(
    private eventService: EventService,
    private plantillaService: PlantillaService,
    private router: Router) { }

    model = {
      nombre: '',
    }

  ngOnInit(): void {
    this.eventService.broadcast(EventType.CHANGE_PAGE_TITLE,
      {
        title: 'Nueva plantilla',
        breadCrumbItems: [{ label: 'Plantillas', path: '.' }, { label: 'Nueva plantilla', path: '.', active: true }]
      }
    );
  }

  onSubmit(form: NgForm) {

    const plantilla: Plantilla = {
      nombre: form.value.nombre,
    };


    
    this.plantillaService.newPlantilla(plantilla)
      .subscribe(res => {
        this.router.navigate(['/plantillas']);
      })
    
  }

}
